import { useStyles } from '../../hooks/useStyles';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { LiveStatusDetailList } from '../liveStatus/LiveStatusDetailList';

export function LiveStatusPage() {
  const { theme, css } = useStyles();

  return (
    <FloatingCardsLayout
      contentSize={650}
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
          classNames={css({overflow: 'hidden'})}
        >
          <LiveStatusDetailList />
        </FloatingCardContent>
      }
    />
  );
}
